module.exports = __webpack_public_path__ + "img/home-service-beijing.7ce5c0a8.png";